export const environment = {
    version: '1.17.6',
    versionCode: 90,
    baseUrl: 'https://api.groovycar.dev',
    baseWsUrl: 'wss://api.groovycar.dev/ws/',
    staging: false,
    production: false
};
